import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Building, ArrowRight, User } from '@saleshandy/icons';
import {
  setSelectedType,
  setCurrentStep,
  setUploadedFile,
  setColumnMapping,
} from '../../csv-enrichment-slice';
import {
  EnrichmentType,
  NewEnrichmentStep,
} from '../../enums/csv-enrichment.enums';
import { RootState } from '../../../../store/root-reducer';

const TYPE_CARDS = [
  {
    type: EnrichmentType.PEOPLE,
    icon: User,
    title: 'Enrich People',
    description:
      'Find email addresses, phone numbers, and profile information for individuals',
  },
  {
    type: EnrichmentType.COMPANY,
    icon: Building,
    title: 'Enrich Companies',
    description:
      'Get comprehensive company information including size, industry, and social profiles',
  },
];

const SelectTypeStep: React.FC = () => {
  const dispatch = useDispatch();
  const { selectedType, uploadedFile } = useSelector(
    (state: RootState) => state.csvEnrichment,
  );

  const handleSelectType = (type: EnrichmentType) => {
    if (type !== selectedType && uploadedFile) {
      dispatch(setUploadedFile(null));
      dispatch(
        setColumnMapping({
          firstName: null,
          lastName: null,
          companyName: null,
          companyDomain: null,
          linkedinUrl: null,
        }),
      );
    }
    dispatch(setSelectedType(type));
    dispatch(setCurrentStep(NewEnrichmentStep.UPLOAD_MAP));
  };

  return (
    <div className="bs-csv-enrichment__select-type">
      {/* <h3 className="semibold-4 gray-txt-9 text-center">
        Choose Enrichment Type
      </h3>
      <p className="regular-2 gray-txt-11 text-center">
        Select whether you want to enrich people or company data
      </p> */}

      <div className="bs-csv-enrichment__type-cards">
        {TYPE_CARDS.map((card) => {
          const IconComponent = card.icon;
          return (
            <div
              key={card.type}
              className="bs-csv-enrichment__type-card bs-csv-enrichment__type-card--clickable"
              onClick={() => handleSelectType(card.type)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) =>
                e.key === 'Enter' && handleSelectType(card.type)
              }
            >
              <div className="bs-csv-enrichment__type-card-icon">
                <IconComponent width={32} height={32} />
              </div>
              <div className="d-flex flex-column gap-8">
                <span className="title">{card.title}</span>
                <span className="description">{card.description}</span>
              </div>
              <span className="bs-csv-enrichment__get-started">
                Get started
                <ArrowRight width={16} height={16} color="#1d4ed8" />
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SelectTypeStep;
